import * as _ from "lodash";
var StatisticsCache = /** @class */ (function () {
    function StatisticsCache() {
        var _this = this;
        this.get = function (url, filter) {
            return new Promise(function (resolve, reject) {
                var toRet = _.find(_this.statistics, function (s) { return s.url === url && _.isEqual(s.filter, filter); });
                //            console.log(toRet);
                if (!toRet) {
                    var pending = _.find(_this.pending, function (p) { return p.url === url && _.isEqual(p.filter, filter); });
                    if (!pending) {
                        // load from back-end
                        //                    console.log("load from back-end");
                        var promise = void 0;
                        //                    console.log(url);
                        if (typeof url === "function")
                            promise = url();
                        else
                            promise = new Promise(function (r) { return r(url); });
                        _this.pending.push({ url: url, filter: filter, promise: promise });
                        promise.then(function (data) {
                            _this.statistics.push({ url: url, filter: filter, data: data });
                            var idx = _.findIndex(_this.pending, function (p) { return p.url === url && _.isEqual(p.filter, filter); });
                            if (idx >= 0)
                                _this.pending.splice(idx, 1);
                            resolve(data);
                        }, function () { return reject("failed on back-end"); });
                    }
                    else {
                        //                    console.log("found pending...");
                        pending.promise.then(function (data) {
                            _this.statistics.push({ url: url, filter: filter, data: data });
                            resolve(data);
                        }, function () { return reject("failed on pending"); });
                    }
                }
                else {
                    //                console.log("found last one...");
                    resolve(toRet.data);
                }
            });
        };
        this.statistics = [];
        this.pending = [];
    }
    StatisticsCache.getInstance = function () {
        if (!this.instance)
            this.instance = new StatisticsCache();
        return this.instance;
    };
    Object.defineProperty(StatisticsCache, "store", {
        set: function (val) {
            this.currentStore = val;
        },
        enumerable: true,
        configurable: true
    });
    return StatisticsCache;
}());
export default StatisticsCache;
//# sourceMappingURL=StatisticsCache.js.map